const popover = {
	elements: {
		$popoverButton: $('.js-popover-button'),
		$popoverContent: $('.js-popover-content'),
	},

	selectors: {
		popoverParent: '.js-popover-parent',
	},

	modifiers:{
		popoverButtonActive: 'popover__button--active',
	},

	init() {
		this.initEvents()
	},

	initEvents() {
		this.elements.$popoverButton.on('click', this.togglePopover.bind(this))
		this.elements.$popoverButton.on('keydown', this.handleKeyToggle.bind(this))
	},

	handleKeyToggle(e){
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			this.togglePopover.call(this, e)
		}
	},

	togglePopover(e){
		const $currentButton = $(e.currentTarget)
		const dataTarget = $currentButton.data('target')
		const $targetContent = this.elements.$popoverContent.filter(`[data-id="${dataTarget}"]`)
		const isInert = $targetContent.prop('inert')

		$targetContent.prop('inert', !isInert)
		$currentButton.toggleClass(this.modifiers.popoverButtonActive, isInert)

		if(!isInert){
			return
		}

		const $container      = $currentButton.closest(this.selectors.popoverParent)
		const containerOffset = $container.offset()
		let absLeft, absTop

		// Triggered by a mouse click (e.pageX / e.pageY are available)
		if (typeof e.pageX === 'number' && typeof e.pageY === 'number') {
			absLeft = e.pageX
			absTop  = e.pageY
		} else {
			// Triggered by Enter/Space key
			const btnOffset = $currentButton.offset()
			absLeft = btnOffset.left
			absTop  = btnOffset.top + $currentButton.outerHeight()
		}

		const popW  = $targetContent.outerWidth()
		const popH  = $targetContent.outerHeight()
		const bodyW = $(document).width()
		const bodyH = $(document).height()
		const margin = 20

		absLeft = Math.max(margin, Math.min(absLeft, bodyW - popW - margin))
		absTop  = Math.max(margin, Math.min(absTop, bodyH - popH - margin))

		const left = absLeft - containerOffset.left
		const top  = absTop  - containerOffset.top

		$targetContent.css({
			'--popover-inset-block-start':  `${top + 20}px`,
			'--popover-inset-inline-start': `${left}px`,
		})

		$(document).on('mousedown.popover', (evt) => {
			const $target = $(evt.target)

			if (
				!$target.is($currentButton) &&
				$target.closest($targetContent).length === 0
			) {
				$targetContent.prop('inert', true)
				$currentButton.removeClass(this.modifiers.popoverButtonActive)
				$(document).off('mousedown.popover')
			}
		})
	},
}

popover.init()